import store from "../store";
import { BUSINESS_UPDATE, ERROR_INITIAL, ERROR_UPDATE, PRODUCT_INITIAL, PRODUCT_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";
import { ImageInstance } from "./imageClass";

class BrandClass {
  constructor() { }

  public getProducts = async (id: string) => {
    try {
      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...PRODUCT_INITIAL,
            isLoading: true,
          },
        }),
      );

      const data = {
        endpoint: `brands/get-products/${id}`,
      };

      const products = await DatabaseInstance.getRecord(data);

      console.log("products", products);


      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            isLoading: false,
            products,
          },
        }),
      );

      return products;
    } catch (error) {
      console.error(error);
    }
  };

  public removeProduct = async (brandId: string, product: any) => {
    try {
      console.log("removing product:", product, "from brand:", brandId);

      if (product.brandId !== brandId) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...ERROR_INITIAL,
              error: true,
              message: "Cannot remove product from another brand.",
            },
          }),
        );
        return;
      }

      const data = {
        endpoint: `products/delete/${product.id}`,
      };

      const response = await DatabaseInstance.deleteRecord(data);

      console.log("response", response);

      if (!response) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...store.getState().error,
              error: true,
              message: `Something went wrong removing the menu item. Please try again. "${response.message}"`,
            },
          }),
        );
        return;
      }

      store.dispatch(
        PRODUCT_UPDATE({
          data: {
            ...store.getState().product,
            products: store.getState().product.products.filter((product: any) => product.id !== product.id),
          },
        }),
      );
      return;
    } catch (error: any) {
      console.error(error);
      // store.dispatch(
      //   ERROR_UPDATE({
      //     data: {
      //       ...store.getState().error,
      //       error: true,
      //       message: `Something went wrong removing the menu item. Please try again. "${error.response.data.error}"`
      //     }
      //   })
      // )
    }
  };

  //use this as example for addBrandToDB and addVenueToDB for adminClass
  public addProduct = async ({
    brandId,
    product,
    displayImg,
    avatarImg,
  }: {
    brandId: string | undefined;
    product: any;
    displayImg?: any; //optional for admin add Product
    avatarImg?: any; //optional for admin add Product
  }) => {
    store.dispatch(
      PRODUCT_UPDATE({
        data: {
          ...store.getState().product,
          isLoading: true,
        },
      }),
    );

    // Initialize as null so we can conditionally request them
    let displayImgRes = null;
    let avatarImgRes = null;

    if (displayImg) {
      displayImgRes = await ImageInstance.uploadImageToS3(displayImg, "products", product.name);
    }

    console.log("PRODUCT IN ADD PRODUCT:", avatarImg);
    if (avatarImg) {
      avatarImgRes = await ImageInstance.uploadImageToS3(avatarImg, "products", product.name, true);
    }

    // Check if uploads (if attempted) were successful
    if ((displayImg && !displayImgRes) || (avatarImg && !avatarImgRes)) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to upload image to S3.",
          },
        }),
      );
      return;
    }

    // Construct product data, including image URLs if available
    const productData = {
      ...product,
      ...(displayImgRes && { displayUrl: displayImgRes.fileKey }),
      ...(avatarImgRes && { avatarUrl: avatarImgRes.fileKey }),
      brandId,
    };

    const databaseData = {
      endpoint: `products/add-product`,
      data: productData,
    };

    const record = await DatabaseInstance.createRecord(databaseData);
    console.log("productData", productData);

    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to add product to database.",
          },
        }),
      );
      return false;
    }

    store.dispatch(
      PRODUCT_UPDATE({
        data: {
          ...store.getState().product,
          isLoading: false,
        },
      }),
    );

    return true;
  };

  public updateProduct = async ({
    data,
    id,
    avatarImg,
    displayImg,
  }: {
    data: any;
    id: number;
    avatarImg: any;
    displayImg: any;
  }) => {

    console.log('data', data)
    store.dispatch(
      PRODUCT_UPDATE({
        data: {
          ...store.getState().product,
          isLoading: true,
        },
      }),
    );

    if (avatarImg) {
      const avatarImgRes = await ImageInstance.uploadImageToS3(
        avatarImg,
        "products",
        data.name.replace(/\s/g, ""),
        true,
      );

      avatarImgRes && (data.avatarUrl = avatarImgRes.fileKey);
      // data.avatarUrl = avatarImgRes.fileKey;
    }

    if (displayImg) {
      const displayImgRes = await ImageInstance.uploadImageToS3(displayImg, "products", data?.name?.replace(/\s/g, ""));

      displayImgRes && (data.displayUrl = displayImgRes.fileKey);
    }

    if (data.name) {
      data.name = data.name.trim();
    }

    const databaseData = {
      endpoint: `products/update/${id}`,
      data: data,
    };

    console.log("databaseData", databaseData);

    const record = await DatabaseInstance.updateRecord(databaseData);

    console.log("record");

    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to update product in database.",
          },
        }),
      );
      return false;
    }

    // find the products in the product state and update the product
    const products = store.getState().product.products;

    // update the product in the products array but keep the rest of the product in the productArray but update with new stuff

    const updatedProducts = products.map((product: any) => {
      if (product.id === id) {
        return {
          ...product,
          ...record,
        };
      }
      return product;
    });

    console.log("updatedProducts", updatedProducts);

    store.dispatch(
      PRODUCT_UPDATE({
        data: {
          ...store.getState().product,
          isLoading: false,
          products: updatedProducts,
        },
      }),
    );

    return true;
  };

  public updateBrand = async (oldData: any, newData: any) => {
    try {
      store.dispatch(
        BUSINESS_UPDATE({
          data: {
            ...store.getState().business,
            isLoading: true,
          },
        }),
      );
      const alteredData = this.checkForDifferencesInBrandData(oldData, newData);

      // if alteredData includes displayUrl or avatarUrl, then we need to upload the image to the server and get the url
      if (alteredData.displayUrl) {
        const res = await ImageInstance.uploadImageToS3(alteredData.displayUrl, "brands", oldData.name, false);

        if (!res) {
          // TODO: RENDER AN ERROR MESSAGE IN THE UPLOAD IMAGE TO S3 FUNCTION
          return;
        }

        const fileKey = res.fileKey;

        alteredData.displayUrl = fileKey;
      }

      if (alteredData.avatarUrl) {
        const res = await ImageInstance.uploadImageToS3(alteredData.avatarUrl, "brands", oldData.name, true);

        if (!res) {
          return;
        }

        const fileKey = res.fileKey;

        alteredData.avatarUrl = fileKey;
      }

      console.log("alteredData: ", alteredData);

      const data = {
        endpoint: `brands/update/${oldData.id}`,
        data: alteredData,
        headers: {
          actingasid: oldData.id,
          actingastype: "brand",
        },
      };

      const response = await DatabaseInstance.updateRecord(data);

      if (!response) {
        store.dispatch(
          ERROR_UPDATE({
            data: {
              ...store.getState().error,
              error: true,
              message: `Something went wrong updating the venue. Please try again. "${response.message}"`,
            },
          }),
        );
        return;
      }

      store.dispatch(
        BUSINESS_UPDATE({
          data: {
            ...store.getState().business,
            activeBusiness: {
              ...response,
            },
            isLoading: false,
          },
        }),
      );

      console.log("response", response);
      return response;
    } catch (error: any) {
      console.error(error);
    }
  };

  private checkForDifferencesInBrandData = (oldData: any, newData: any) => {
    console.log("oldData: ", oldData);
    console.log("newData: ", newData);
    const differences: { [key: string]: any } = {};

    const keys = Object.keys(oldData);

    for (let i = 0; i < keys.length; i++) {
      if (oldData[keys[i]] !== newData[keys[i]]) {
        differences[keys[i]] = newData[keys[i]];
      }
    }

    return differences;
  };
}

const BrandInstance = new BrandClass();

export { BrandInstance };

// user fills out the details of the product
// user selects the display image
// user selects the thumbnail image
// user submits the product
// the submit function first uploads the images to S3
// then it uses the key for the images and adds the s3 bucket url
